<template>
  <div
    class="time-slider"
    style="padding: 0 0 15px 0;"
  >
    <label>Start Time</label>
    <vue-slider

      v-model="sliderValue"
      :min="minMinutes"
      :max="maxMinutes"
      :interval="validInterval"
      :marks="marks"
      :dot-size="18"
      :tooltip-formatter="formatMinutes"
      :process-style="{ backgroundColor: 'var(--attendee-brand-color)' }"
      :contained="true"
      :lazy="true"
      range
      @change="emitChange"
    >
      <template slot="step" slot-scope="{ value, active }">
        <div :class="['time-slider__step', { active }]"></div>
      </template>

      <template slot="dot" slot-scope="{ value, focus }">
        <div :class="['time-slider__dot', { focus }]"></div>
      </template>
    </vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'TimeRangeSlider',
  components: { VueSlider },

  props: {
    value: {
      type: Array,
      default: () => []
    },
    startTime: {
      type: String,
      default: '01:00 AM'
    },
    endTime: {
      type: String,
      default: '11:00 PM'
    }
  },

  data() {
    const minMinutes = this.timeToMinutes(this.startTime);
    const maxMinutes = this.timeToMinutes(this.endTime);
    const mid = Math.floor((minMinutes + maxMinutes) / 2);

    const initialRange = this.value.length
      ? this.value.map(t => this.timeToMinutes(t))
      : [minMinutes, maxMinutes];

    return {
      minMinutes,
      maxMinutes,
      mid,
      sliderValue: initialRange,
      marks: {
        [minMinutes]: this.formatMinutes(minMinutes),
        [mid]: { label: this.formatMinutes(mid) },
        [maxMinutes]: this.formatMinutes(maxMinutes)
      }
    }
  },

  computed: {
    validInterval() {
      const range = this.maxMinutes - this.minMinutes
      if (range % 10 === 0) return 10;
      if (range % 5 === 0) return 5;
      return 1;
    }
  },

  watch: {
    value(newVal) {
      if (Array.isArray(newVal) && newVal.length === 2) {
        const next = newVal.map(t => this.timeToMinutes(t));
        this.sliderValue = this.clampRange(next);
      }
    },
    startTime() {
      this.updateBoundsOnly();
    },
    endTime() {
      this.updateBoundsOnly();
    }
  },

  methods: {
    emitChange() {
      const sorted = [...this.sliderValue].sort((a, b) => a - b)
      const clamped = this.clampRange(sorted)
      this.sliderValue = clamped;

      const timeRange = clamped.map(m => this.formatMinutes(m))
      this.$emit('input', timeRange)
      this.$emit('change', timeRange)
    },

    timeToMinutes(timeStr) {
      const [time, meridiem] = timeStr.split(' ')
      let [hours, minutes] = time.split(':').map(Number)
      if (meridiem === 'PM' && hours !== 12) hours += 12
      if (meridiem === 'AM' && hours === 12) hours = 0
      return hours * 60 + minutes
    },

    formatMinutes(total) {
      const hours = Math.floor(total / 60)
      const minutes = total % 60
      const ampm = hours >= 12 ? 'PM' : 'AM'
      const displayHour = hours % 12 || 12
      const displayMinutes = minutes.toString().padStart(2, '0')
      return `${displayHour}:${displayMinutes} ${ampm}`
    },

    clampRange(range) {
      const min = this.minMinutes
      const max = this.maxMinutes
      const a = Math.min(Math.max(range[0], min), max)
      const b = Math.min(Math.max(range[1], min), max)
      return a <= b ? [a, b] : [b, a]
    },

    updateBoundsOnly() {
      const minMinutes = this.timeToMinutes(this.startTime)
      const maxMinutes = this.timeToMinutes(this.endTime)
      const mid = Math.floor((minMinutes + maxMinutes) / 2)

      this.minMinutes = minMinutes
      this.maxMinutes = maxMinutes
      this.mid = mid

      this.marks = {
        [minMinutes]: this.formatMinutes(minMinutes),
        [mid]: { label: this.formatMinutes(mid) },
        [maxMinutes]: this.formatMinutes(maxMinutes)
      }

      this.sliderValue = this.clampRange(this.sliderValue)
    },

    // updateRange() {
    //   const minMinutes = this.timeToMinutes(this.startTime)
    //   const maxMinutes = this.timeToMinutes(this.endTime)
    //   const mid = Math.floor((minMinutes + maxMinutes) / 2)
    //
    //   this.minMinutes = minMinutes
    //   this.maxMinutes = maxMinutes
    //   this.mid = mid
    //   this.sliderValue = [minMinutes, maxMinutes]
    //   this.$emit('input', [
    //     this.formatMinutes(minMinutes),
    //     this.formatMinutes(maxMinutes)
    //   ])
    //
    //   this.marks = {
    //     [minMinutes]: this.formatMinutes(minMinutes),
    //     [mid]: { label: this.formatMinutes(mid) },
    //     [maxMinutes]: this.formatMinutes(maxMinutes)
    //   }
    // }
  }
}
</script>

<style lang="scss">
.time-slider {
  padding: 0px 5px 15px 5px !important;

  .vue-slider-mark {
    &:first-child {
      .vue-slider-mark-label {
        //padding-left: 32px;

        transform: translateX(-10%);
      }
    }

    &:last-child {
      .vue-slider-mark-label {
        transform: translateX(-90%);
        //padding-right: 32px;
      }
    }
  }

  //.vue-slider-dot-tooltip-top{
  //  left: -6px;
  //}

  label {
    color: var(--attendee-text-secondary-color);
    font-size: 16px;
    gap: var(--attendee-gap-sm);
    font-weight: 400;
  }

  .vue-slider-mark-label {
    color: var(--attendee-text-primary-color);
    font-size: 12px;
    font-weight: 500;
  }
}

.time-slider__dot {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: white;
  border: 1px solid var(--attendee-border-color);
  transition: all 0.3s;
}

.time-slider__step {
  box-shadow: 0 0 0 2px #e8e8e8;
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transition: all 0.3s;

  &.active {
    box-shadow: 0 0 0 2px var(--attendee-brand-color);
  }
}

.vue-slider {
  width: 100%;
}
</style>